/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 週次リポート
 * @export
 * @interface WeeklyReportsRow
 */
export interface WeeklyReportsRow {
    /**
     * 乗務員ID
     * @type {number}
     * @memberof WeeklyReportsRow
     */
    driverId?: number;
    /**
     * 乗務員名
     * @type {string}
     * @memberof WeeklyReportsRow
     */
    driverName?: string;
    /**
     * 乗務員番号
     * @type {string}
     * @memberof WeeklyReportsRow
     */
    driverCode?: string;
    /**
     * 改善コメント
     * @type {string}
     * @memberof WeeklyReportsRow
     */
    instructionMessage?: string;
    /**
     * (改善コメントのID)
     * @type {number}
     * @memberof WeeklyReportsRow
     */
    instructionId?: number;
    /**
     * (改善コメントの優先順位)
     * @type {number}
     * @memberof WeeklyReportsRow
     */
    instructionPriority?: number;
    /**
     * (営業所ID)
     * @type {number}
     * @memberof WeeklyReportsRow
     */
    officeId?: number;
    /**
     * 期間乗務回数
     * @type {number}
     * @memberof WeeklyReportsRow
     */
    numShift?: number;
    /**
     * 平均営収
     * @type {number}
     * @memberof WeeklyReportsRow
     */
    meanTotalAmountPerShift?: number;
    /**
     * 営業所平均
     * @type {number}
     * @memberof WeeklyReportsRow
     */
    meanOfficeTotalAmountPerShift?: number;
    /**
     * worst乗務
     * @type {string}
     * @memberof WeeklyReportsRow
     */
    worstShiftId?: string;
    /**
     * 声かけフラグ
     * @type {boolean}
     * @memberof WeeklyReportsRow
     */
    feedbackGivenFlag?: boolean;
    /**
     * week
     * @type {number}
     * @memberof WeeklyReportsRow
     */
    weekNo?: number;
    /**
     * week
     * @type {number}
     * @memberof WeeklyReportsRow
     */
    year?: number;
}

export function WeeklyReportsRowFromJSON(json: any): WeeklyReportsRow {
    return WeeklyReportsRowFromJSONTyped(json, false);
}

export function WeeklyReportsRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeeklyReportsRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'driverId': !exists(json, 'driver_id') ? undefined : json['driver_id'],
        'driverName': !exists(json, 'driver_name') ? undefined : json['driver_name'],
        'driverCode': !exists(json, 'driver_code') ? undefined : json['driver_code'],
        'instructionMessage': !exists(json, 'instruction_message') ? undefined : json['instruction_message'],
        'instructionId': !exists(json, 'instruction_id') ? undefined : json['instruction_id'],
        'instructionPriority': !exists(json, 'instruction_priority') ? undefined : json['instruction_priority'],
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'numShift': !exists(json, 'num_shift') ? undefined : json['num_shift'],
        'meanTotalAmountPerShift': !exists(json, 'mean_total_amount_per_shift') ? undefined : json['mean_total_amount_per_shift'],
        'meanOfficeTotalAmountPerShift': !exists(json, 'mean_office_total_amount_per_shift') ? undefined : json['mean_office_total_amount_per_shift'],
        'worstShiftId': !exists(json, 'worst_shift_id') ? undefined : json['worst_shift_id'],
        'feedbackGivenFlag': !exists(json, 'feedback_given_flag') ? undefined : json['feedback_given_flag'],
        'weekNo': !exists(json, 'week_no') ? undefined : json['week_no'],
        'year': !exists(json, 'year') ? undefined : json['year'],
    };
}

export function WeeklyReportsRowToJSON(value?: WeeklyReportsRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'driver_id': value.driverId,
        'driver_name': value.driverName,
        'driver_code': value.driverCode,
        'instruction_message': value.instructionMessage,
        'instruction_id': value.instructionId,
        'instruction_priority': value.instructionPriority,
        'office_id': value.officeId,
        'num_shift': value.numShift,
        'mean_total_amount_per_shift': value.meanTotalAmountPerShift,
        'mean_office_total_amount_per_shift': value.meanOfficeTotalAmountPerShift,
        'worst_shift_id': value.worstShiftId,
        'feedback_given_flag': value.feedbackGivenFlag,
        'week_no': value.weekNo,
        'year': value.year,
    };
}


